import { Trash2 } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { XStack, YStack } from "tamagui";
import { useStores } from "../../../core/stores";
import { Box } from "../../../ui/Box";
import { Button } from "../../../ui/Button";
import { Group } from "../../../ui/Group";
import { Label } from "../../../ui/Label";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import { AvatarSize, UserPropsAvatar } from "../../../ui/UserAvatar";
import type { BusinessCustomerModel } from "../customers/BusinessCustomerModel";
import { BusinessInfoRow } from "../ui/BusinessInfoRow";

export const BusinessAdminUsersList = observer(
  ({ customer }: { customer: BusinessCustomerModel }) => {
    const admins = customer.admins;

    const { sessionStore } = useStores();

    const applyingUsers = customer.applyingUsers;

    return (
      <YStack gap={"$medium"}>
        {applyingUsers.length > 0 && (
          <Box gap={"$large"}>
            <BusinessInfoRow
              title={
                "These users are applying for access. Please accept or decline."
              }
            />

            <Group>
              {applyingUsers.map((user) => {
                return (
                  <XStack
                    key={user.superUserUid}
                    gap={"$medium"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <XStack gap={"$medium"} alignItems={"center"}>
                      <UserPropsAvatar {...user} size={AvatarSize.Medium} />
                      <Label>{user.displayName}</Label>
                    </XStack>
                    <XStack gap={"$medium"}>
                      <PopoverConfirm
                        confirmTitle={
                          "Accepting this member will make them admins."
                        }
                        onConfirm={() => {
                          customer.acceptApplication(user.superUserUid);
                        }}
                      >
                        <Button>Accept</Button>
                      </PopoverConfirm>
                      <PopoverConfirm
                        confirmTitle={
                          "Declining this member will remove them as applying."
                        }
                        onConfirm={() => {
                          customer.declineApplication(user.superUserUid);
                        }}
                      >
                        <Button type={"secondary"}>Decline</Button>
                      </PopoverConfirm>
                    </XStack>
                  </XStack>
                );
              })}
            </Group>
          </Box>
        )}

        <Box gap={"$large"}>
          <BusinessInfoRow
            title={"Your current admins, everyone here can access this admin."}
          />
          <Label>Admins ({admins.length})</Label>

          <Group>
            {admins.map((admin) => {
              const canEdit =
                admins.length > 1 &&
                admin.superUserUid !== sessionStore.superUserUid;

              return (
                <XStack
                  key={admin.superUserUid}
                  gap={"$medium"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  width={"100%"}
                >
                  <XStack gap={"$medium"} alignItems={"center"}>
                    <UserPropsAvatar {...admin} size={AvatarSize.Medium} />
                    <Label>{admin.displayName}</Label>
                  </XStack>
                  {canEdit && (
                    <XStack gap={"$medium"}>
                      <PopoverConfirm
                        confirmTitle={
                          "Deleting this admin will make them loose access."
                        }
                        onConfirm={() => {
                          customer.removeAdmin(admin.superUserUid);
                        }}
                      >
                        <Trash2 size={"$size.normal"} color={"$muted"} />
                      </PopoverConfirm>
                    </XStack>
                  )}
                </XStack>
              );
            })}
          </Group>
        </Box>
        <Button
          onPress={() => {
            // Add admin
            alert("TODO - this needs to be added");
          }}
        >
          Add admin
        </Button>
      </YStack>
    );
  },
);
